import { render, staticRenderFns } from "./TgHeaderTitle.vue?vue&type=template&id=64a01de7"
import script from "./TgHeaderTitle.vue?vue&type=script&lang=js"
export * from "./TgHeaderTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports